import { GeoJsonLayer } from "@deck.gl/layers";
import type { GeoJSON } from "geojson";

export const initGeoJsonLayer = (geoJson: GeoJSON | null) =>
  new GeoJsonLayer({
    id: "geojson-layer",
    data: geoJson ?? undefined,
    stroked: true,
    filled: true,
    pointType: "circle",
    pointRadiusUnits: "pixels",
    getPointRadius: 4,
    extruded: false,
    lineWidthScale: 20,
    lineWidthMinPixels: 2,
    getLineColor: [255, 0, 0, 255],
    getFillColor: [200, 200, 200, 200],
    getLineWidth: 1,
    getElevation: 30,
  });
